export const nativeService = (messageString: string) => {
  const nativeWebView = (window as any)?.ReactNativeWebView;
  const hasWebView = !!nativeWebView;

  if (hasWebView) {
    nativeWebView.postMessage(messageString);
  }
};
